import React, { useState } from "react";
import Utils from "../../utils/Utils";

export const SqPoints = ({ show = true }) => {
  const [loaderStatus, setLoaderStatus] = useState(true);

  const pageUrl = "/api/explained/sq-avg-points";

  return (
    <>
      <div className="container stats-explained">
        <h2 style={{ marginBottom: "50px" }}>SQ Points & SQ PPP</h2>
        <div className="gray-background-container" style={{ marginBottom: "50px" }}>
          <h5 className="sq-points-tittle" style={{ marginBottom: "30px" }}>
            SQ Points
          </h5>
          <p className="text-template">
            A player's SQpoints are the accumulation of all individual ShotQuality points in each game. Here's an
            example that illustrates this calculation.
          </p>
          <p className="bold-text">Let's say Player-X takes the following shots:</p>
          <p className="text-template">
            <p className="text-template" style={{ marginBottom: "8px" }}>
              A 2-point mid range that ShotQuality predicts he makes 40% of the time
            </p>
            <p className="text-template" style={{ marginBottom: "8px" }}>
              A 3-pointer off the dribble that shot quality predicts he makes 20% of the time: individual SQ = 0.6
            </p>
            <p className="text-template" style={{ marginBottom: "24px" }}>
              A 2-point layup that he makes 95% of the time: individual SQ = 1.9
            </p>
          </p>
          <p className="text-template">Then, Player-X's total SQpoints for the game = 0.8+0.6+1.9 = 3.3</p>
        </div>

        <div className="gray-background-container" style={{ marginBottom: "50px" }}>
          <h5 className="sq-points-tittle" style={{ marginBottom: "30px" }}>
            SQppp
          </h5>
          <p className="text-template">
            <p>SQppp is a player's average ShotQuality points per possession.</p>
            <p>Thus, SQppp = Total SQpoints/Total No. Of Possessions</p>
          </p>
          <p className="bold-text">
            <p className="bold-text" style={{ marginBottom: "8px" }}>
              Let's say Player-Y has 25 SQpoints and 20 possessions in a game.
            </p>
            <p className="bold-text" style={{ marginBottom: "8px" }}>
              Then, SQppp = 25/20 = 1.25
            </p>
          </p>
        </div>

        <h5 className="sq-points-tittle">SQppp Ratings Table</h5>

        <div className="row align-items-center" style={{ marginBottom: "150px" }}>
          <div className="box col-lg-12">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th className="w-50">
                      Rating
                      {/* <i className="fa fa-sort-desc" aria-hidden="true" /> */}
                    </th>
                    <th className="w-50">
                      SQ PPP
                      {/* <i className="fa fa-sort-desc" aria-hidden="true" /> */}
                      <div className="tooltipCon">
                        <b className="d-block">Shot Quality PPP</b>
                        Total SQ points scored divided by total possessions
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Excellent</td>
                    <td>1.10 or more</td>
                  </tr>
                  <tr>
                    <td>Great</td>
                    <td>1.05</td>
                  </tr>
                  <tr>
                    <td>Above Average</td>
                    <td>1.0</td>
                  </tr>
                  <tr>
                    <td>Average</td>
                    <td>0.95</td>
                  </tr>
                  <tr>
                    <td>Below Average</td>
                    <td>0.90</td>
                  </tr>
                  <tr>
                    <td>Poor</td>
                    <td>0.85</td>
                  </tr>
                  <tr>
                    <td>Awful</td>
                    <td>0.80 or less</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
